import RocketsContainer from '../components/RocketsContainer';
import '../stylesheets/Rockets.css';

const Rockets = () => (
  <div className="rockets">
    <RocketsContainer />
  </div>
);

export default Rockets;
